import menu from './menu'
import table from './table'
import testmail from './testmail'

export default {
    type: 'Typ',
    name: 'Name',
    subject: 'Betreff',
    subjectPlaceholder: 'Betreff...',
    body: 'Inhalt',
    bodyPlaceholder: 'Inhalt der E-Mail...',
    bodyInfo: 'Zur Generierung von dynamischen Inhalten verwenden wir die sogenannte Blade-Syntax. Diese ermöglicht es, Variablen in den E-Mail-Inhalt einzufügen und Blöcke über einfache Bedingungen einzublenden.',
    bodyInfo2: 'Die Variablen werden von uns bereits gehandhabt und können direkt im Text verwendet werden. Um aber auf Blade Funktionen wie "if"," "foreach", etc. zurückzugreifen, muss der zugehörige Text in einem Code-Block (Editor-Button [</>]) stehen. Hier muss dann die Blade-Syntax bei den Variablen verwendet werden (siehe Beispiel). Der Code-Block wird dann von uns als Blade-Code interpretiert.',
    updateSuccess: 'Die E-Mail-Vorlage wurde erfolgreich aktualisiert.',
    de: 'Deutsch',
    en: 'Englisch',
    global: 'Global',
    organisation_id: 'Organisations-ID',

    template: 'Vorlage',
    emailSettings: 'Mail-Einstellungen',
    bcc: "Kopie-Adresse(n) (BCC)",
    bccDescription: "E-Mail-Adressen, die eine Kopie der E-Mail erhalten sollen. Mehrere Adressen können durch \";\" getrennt werden.",
    replyToEmail: "Antwort-Adresse (Reply-To)",
    replyToName: "Antwort-Name (Reply-To)",
    replyToEmailDescription: "E-Mail-Adresse, die als Antwort-Adresse für die E-Mail verwendet werden soll.",
    replyToNameDescription: "Name, der für die Antwort-Adresse der E-Mail verwendet werden soll.",

    copyMailTemplateForOwnAssociation: 'E-Mailvorlage für eigenen Verband kopieren',

    class: 'Gehört zu',
    subject_de: 'Betreff (Deutsch)',
    subject_en: 'Betreff (Englisch)',
    content_de: 'Inhalt (Deutsch)',
    content_en: 'Inhalt (Englisch)',
    variables_subject: 'Verfügbare Variablen für den Betreff',
    variables_content: 'Verfügbare Variablen für den Inhalt',

    deleteMailTemplate: 'E-Mailvorlage löschen',
    deleteMailTemplateText: 'Möchten Sie diese E-Mailvorlage wirklich löschen?',
    saveSuccess: 'Die E-Mailvorlage wurde erfolgreich gespeichert.',
    saveError: 'Beim Speichern der E-Mailvorlage ist ein Fehler aufgetreten.',
    deleteMailTemplateSuccess: 'Die E-Mailvorlage wurde erfolgreich gelöscht.',
    deleteMailTemplateError: 'Beim Löschen der E-Mailvorlage ist ein Fehler aufgetreten.',

    menu,
    table,
    testmail
}